import { render } from "./index.vue?vue&type=template&id=f85c18ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f85c18ea&scoped=true&lang=scss"

import exportComponent from "/Users/luochen/Desktop/allBox/221101/SIA官网/siaindex/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85c18ea"]])

export default __exports__